"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllValidModifiersForModifierGroup = exports.getStudioModifiers = exports.getFullModifier = void 0;
const validation_1 = require("./validation");
const core_1 = require("@natomas-org/core");
const getFullModifier = (generalModifier, productModifier) => {
    const finalModifier = Object.assign({}, generalModifier, productModifier);
    const productPriceSet = productModifier === null || productModifier === void 0 ? void 0 : productModifier.price_set;
    const globalPriceSet = generalModifier === null || generalModifier === void 0 ? void 0 : generalModifier.price_set;
    if (productPriceSet && globalPriceSet) {
        // Determine if we should use the product-level pricing or product-group level pricing
        // If there is a price set on the product-level, use that pricing set
        let isDefaultPriceOverwritten = false;
        let accumulatedPriceSet = productPriceSet.filter((price) => {
            if (price.price.price != null) {
                if (price.condition === core_1.ModifierPriceCondition.DEFAULT) {
                    isDefaultPriceOverwritten = true;
                }
                return true;
            }
            return false;
        });
        if (!isDefaultPriceOverwritten) {
            accumulatedPriceSet = globalPriceSet.filter((price) => {
                return price.price.price != null;
            });
        }
        finalModifier.price_set = accumulatedPriceSet;
    }
    return finalModifier;
};
exports.getFullModifier = getFullModifier;
const getStudioModifiers = (groupModifiers, productModifiers) => {
    const m = groupModifiers ? Object.values(groupModifiers) : [];
    return m.map((modifier) => {
        return (0, exports.getFullModifier)(modifier, productModifiers === null || productModifiers === void 0 ? void 0 : productModifiers[modifier === null || modifier === void 0 ? void 0 : modifier.id]);
    });
};
exports.getStudioModifiers = getStudioModifiers;
const getAllValidModifiersForModifierGroup = (fullStudioStructure, modifierGroup, selections) => {
    var _a;
    return (_a = modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.fullModifiers) === null || _a === void 0 ? void 0 : _a.filter((modifier) => {
        let shouldCheckValidity = false;
        if ((modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.modifierOverrides) != null &&
            (modifierGroup === null || modifierGroup === void 0 ? void 0 : modifierGroup.modifierOverrides[modifier === null || modifier === void 0 ? void 0 : modifier.id]) != null) {
            shouldCheckValidity = true;
        }
        else if ((modifier === null || modifier === void 0 ? void 0 : modifier.blockingModifiers) != null) {
            shouldCheckValidity = true;
        }
        return shouldCheckValidity
            ? (0, validation_1.isModifierValid)(fullStudioStructure, modifierGroup, modifier, selections)
            : true;
    });
};
exports.getAllValidModifiersForModifierGroup = getAllValidModifiersForModifierGroup;
//# sourceMappingURL=modifier.js.map